/*
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const OrderHistoryPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching orders from an API
    setTimeout(() => {
      const mockOrders = [
        {
          id: 'ORD-1234',
          date: '2025-04-10T18:30:00',
          items: [
            { name: 'Margherita Pizza', quantity: 1, price: 12.99 },
            { name: 'Garlic Breadsticks', quantity: 1, price: 4.99 },
          ],
          restaurant: 'Pizza Palace',
          status: 'Delivered',
          total: 17.98
        },
        {
          id: 'ORD-1235',
          date: '2025-04-05T19:45:00',
          items: [
            { name: 'Chicken Biryani', quantity: 1, price: 15.99 },
            { name: 'Naan Bread', quantity: 2, price: 2.99 },
            { name: 'Mango Lassi', quantity: 1, price: 3.99 },
          ],
          restaurant: 'Spice Garden',
          status: 'Delivered',
          total: 25.96
        },
        {
          id: 'ORD-1236',
          date: '2025-04-11T12:15:00',
          items: [
            { name: 'Beef Burger', quantity: 1, price: 9.99 },
            { name: 'French Fries', quantity: 1, price: 3.99 },
            { name: 'Chocolate Milkshake', quantity: 1, price: 4.99 },
          ],
          restaurant: 'Burger Joint',
          status: 'On the way',
          total: 18.97
        },
        {
          id: 'ORD-1237',
          date: '2025-04-12T10:30:00',
          items: [
            { name: 'Vegetable Pad Thai', quantity: 1, price: 11.99 },
            { name: 'Spring Rolls', quantity: 2, price: 4.99 },
          ],
          restaurant: 'Thai Delight',
          status: 'Preparing',
          total: 21.97
        }
      ];
      
      setOrders(mockOrders);
      setLoading(false);
    }, 1500);
  }, []);

  const getStatusClass = (status) => {
    switch(status) {
      case 'Delivered':
        return 'status-delivered';
      case 'On the way':
        return 'status-onway';
      case 'Preparing':
        return 'status-preparing';
      case 'Pending':
        return 'status-pending';
      default:
        return '';
    }
  };

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div className="order-history-page">
      <div className="page-header">
        <h1>Order History</h1>
        <p>Review your past and current orders</p>
      </div>
      
      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading your orders...</p>
        </div>
      ) : orders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">
            <i className="fas fa-shopping-bag"></i>
          </div>
          <h2>No Orders Yet</h2>
          <p>You haven't placed any orders yet. Start ordering delicious food!</p>
          <Link to="/" className="btn btn-primary">Browse Restaurants</Link>
        </div>
      ) : (
        <div className="orders-container">
          <div className="order-table-header">
            <div className="header-cell">Order ID</div>
            <div className="header-cell">Date</div>
            <div className="header-cell">Restaurant</div>
            <div className="header-cell">Items</div>
            <div className="header-cell">Total</div>
            <div className="header-cell">Status</div>
            <div className="header-cell">Actions</div>
          </div>
          
          {orders.map(order => (
            <div key={order.id} className="order-row">
              <div className="order-cell" data-label="Order ID:">{order.id}</div>
              <div className="order-cell" data-label="Date:">{formatDate(order.date)}</div>
              <div className="order-cell" data-label="Restaurant:">{order.restaurant}</div>
              <div className="order-cell items-cell" data-label="Items:">
                {order.items.map((item, index) => (
                  <div key={index} className="order-item">
                    {item.quantity} × {item.name}
                  </div>
                ))}
              </div>
              <div className="order-cell" data-label="Total:">${order.total.toFixed(2)}</div>
              <div className="order-cell" data-label="Status:">
                <span className={`status-badge ${getStatusClass(order.status)}`}>
                  {order.status}
                </span>
              </div>
              <div className="order-cell actions-cell" data-label="Actions:">
                <button className="btn btn-sm btn-outline">Reorder</button>
                {order.status === 'Delivered' && (
                  <Link to={`/rate/${order.id}`} className="btn btn-sm btn-outline">
                    Rate Order
                  </Link>
                )}
                <button className="btn btn-sm btn-text">Details</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistoryPage;*/
/*code updated */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const OrderHistoryPage = () => {
  // State for storing orders and loading status
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const userId = localStorage.getItem('user_id');

        const response = await fetch(`https://food.mohamadmansour.me/api/orders?user_id=${userId}`);

        if (!response.ok) throw new Error('Failed to load orders');
        const data = await response.json();
        setOrders(data);
      } catch (err) {
        console.error('Error loading orders:', err);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);


  // Get CSS class for each status
  const getStatusClass = (status) => {
    switch (status) {
      case 'Delivered':
        return 'status-delivered';
      case 'On the way':
        return 'status-onway';
      case 'Preparing':
        return 'status-preparing';
      case 'Pending':
        return 'status-pending';
      default:
        return '';
    }
  };

  // Format the order date
  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div className="order-history-page">
      <div className="page-header">
        <h1>Order History</h1>
        <p>Review your past and current orders</p>
      </div>

      {loading ? (
        // Show loader while fetching data
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading your orders...</p>
        </div>
      ) : orders.length === 0 ? (
        // Empty state if no orders are available
        <div className="empty-state">
          <div className="empty-icon">
            <i className="fas fa-shopping-bag"></i>
          </div>
          <h2>No Orders Yet</h2>
          <p>You haven't placed any orders yet. Start ordering delicious food!</p>
          <Link to="/" className="btn btn-primary">Browse Restaurants</Link>
        </div>
      ) : (
        // Display orders in a table-style layout
        <div className="orders-container">
          <div className="order-table-header">
            <div className="header-cell">Order ID</div>
            <div className="header-cell">Date</div>
            <div className="header-cell">Restaurant</div>
            <div className="header-cell">Items</div>
            <div className="header-cell">Total</div>
            <div className="header-cell">Status</div>
            {/* <div className="header-cell">Actions</div> */}
          </div>

          {orders.map(order => (
            <div key={order.id} className="order-row">
              <div className="order-cell" data-label="Order ID:">{order.id}</div>
              <div className="order-cell" data-label="Date:">{formatDate(order.date)}</div>
              <div className="order-cell" data-label="Restaurant:">{order.restaurant}</div>
              <div className="order-cell items-cell" data-label="Items:">
                {order.items.map((item, index) => (
                  <div key={index} className="order-item">
                    {item.quantity} × {item.name}
                  </div>
                ))}
              </div>
              <div className="order-cell" data-label="Total:">${Number(order.total ?? 0).toFixed(2)}</div>
              <div className="order-cell" data-label="Status:">
                <span className={`status-badge ${getStatusClass(order.status)}`}>
                  {order.status}
                </span>
              </div>
              {/* <div className="order-cell actions-cell" data-label="Actions:">
                <button className="btn btn-sm btn-outline">Reorder</button>
                {order.status === 'Delivered' && (
                  <Link to={`/rate/${order.id}`} className="btn btn-sm btn-outline">
                    Rate Order
                  </Link>
                )}
                <button className="btn btn-sm btn-text">Details</button>
              </div> */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistoryPage;
